import * as mutationTypes from './mutation-types'
import api from '@/store/api/hubspot/property-group'

const initialState = () => ({
    companyProperties: []
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        companyProperties: state => state.companyProperties
    },
    actions: {
        listCompanyProperties: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listCompanyProperties(data)
                commit(mutationTypes.SET_COMPANY_PROPERTIES, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetCompanyProperties: async ({commit}) => commit(mutationTypes.RESET_COMPANY_PROPERTIES)
    },
    mutations: {
        [mutationTypes.SET_COMPANY_PROPERTIES]: (state, data) => state.companyProperties = data,
        [mutationTypes.RESET_COMPANY_PROPERTIES]: state => Object.assign(state, initialState())
    }
}
